/* unplugin-vue-components disabled */import script from "./XFormDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./XFormDialog.vue?vue&type=script&setup=true&lang=ts"

import "./XFormDialog.vue?vue&type=style&index=0&id=6352cccd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6352cccd"]])

export default __exports__